/* eslint-disable no-shadow */
/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import style from "./styles";
import Button from "../common/Button";
import Api from "../../services/api/introductionForm";
import Modal from "../common/Modal/Modal";
import { selectUserProfile } from "../../redux/selectors/user";

const CHAPTER_SI = "chapterSI";
const DISTRICT_SI = "districtSI";
const REGION_SI = "regionSI";
const ZONE_SI = "zoneSI";
const AREA_SI = "areaSI";

function SimpleModal({
  open,
  onClose,
  label,
  profile,
  getUserData,
  districtIdUpdated,
  setDistrictIdUpdated,
  setShowModal,
}) {
  const user = useSelector(selectUserProfile);
  const navigate = useNavigate();
  const additionalRoles = user?.proxyProfile?.additionalRoles || [];
  const handleSwitchProfile = async (structureId) => {
    try {
      const response = await Api.switchProfileData({ districtId: structureId });
      console.log("Switch Profile Response:", response);
      setDistrictIdUpdated(true);
      onClose();
    } catch (error) {
      console.error("Error switching profile:", error);
    }
    getUserData();
    navigate("/");
  };
  const handleOldStructure = async () => {
    const value = profile?.proxyProfile?.originalStructure?.chapterId;
    try {
      const response = await Api.switchProfileData({ districtId: value });
      console.log("Switch Profile Response:", response);
      setDistrictIdUpdated(true);
      onClose();
    } catch (error) {
      console.error("Error switching profile:", error);
    }
    getUserData();
    navigate("/");
  };
  const getCustomLabel = (user) => {
    const role = user?.originalAssignedRoles?.[0];
    const structure = user?.proxyProfile?.originalStructure;

    if (role === CHAPTER_SI && structure?.chapterName) {
      return `Chapter SI - ${structure.chapterName}`;
    }
    if (role === DISTRICT_SI && structure?.districtName) {
      return `District SI - ${structure.districtName}`;
    }
    if (role === REGION_SI && structure?.regionName) {
      return `Region SI - ${structure.regionName}`;
    }
    if (role === ZONE_SI && structure?.zoneName) {
      return `Zone SI - ${structure.zoneName}`;
    }
    if (role === AREA_SI && structure?.areaName) {
      return `Area SI - ${structure.areaName}`;
    }
    return "Default Label";
  };
  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <Modal
      open={open && !districtIdUpdated}
      onClose={onClose}
      customStyle={{ maxHeight: "95%", maxWidth: "95%" }}
      styles={{ backdropFilter: "blur(10px)" }}
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: 5,
          }}
        >
          <Typography style={style.title}>{label}</Typography>
          <IconButton>
            <CloseIcon onClick={closeModal} />
          </IconButton>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Button
            variant="contained"
            label={getCustomLabel(user)}
            onClick={handleOldStructure}
            style={{ width: "100%" }}
          />
          {additionalRoles?.map((role) => (
            <Button
              // key={index}
              variant="contained"
              label={`${role?.roleName} - ${role?.structureName}`}
              onClick={() => handleSwitchProfile(role?.structureId)}
              style={{ width: "100%" }}
            />
          ))}
        </Box>
      </Box>
    </Modal>
  );
}

export default SimpleModal;
